<template>
  <div class="not-found-page">
    <div class="not-found-card">
      <div class="not-found-icon">
        <Icon name="question-circle" variant="solid" color="muted" size="32"/>
      </div>
      <h1 class="not-found-title">
        404
      </h1>
      <p class="not-found-text">
        Page not found. The page you're looking for doesn't exist or has been moved.
      </p>
      <v-btn
        color="primary"
        class="not-found-btn mank-btn"
        elevation="0"
        @click="goHome">
        Go to homepage
      </v-btn>
    </div>
  </div>
</template>

<script>
import Icon from '@/components/Icon.vue';

export default {
  name: 'NotFound',
  components: { Icon },
  methods: {
    goHome() {
      this.$router.push('/');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/colors.scss';
@import '@/styles/variables.scss';

.not-found-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  box-sizing: border-box;
}

.not-found-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  text-align: center;
  max-width: 360px;
}

.not-found-icon {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: $light-surface-2;
  border: 1px solid $light-border;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 4px;
}

.not-found-title {
  margin: 0;
  font-family: $body-font-family;
  font-size: $h4-size;
  font-weight: 700;
  color: $light-foreground-1;
}

.not-found-text {
  margin: 0;
  font-family: $body-font-family;
  font-size: $body-2-size;
  color: $light-foreground-3;
  line-height: 1.5;
}

.not-found-btn {
  margin-top: 8px;
  height: 40px;
  font-family: $body-font-family;
  font-size: $body-3-size;
  font-weight: 600;
}
</style>
